import { render, staticRenderFns } from "./BlockSettings.vue?vue&type=template&id=03e2b24c&scoped=true"
import script from "./BlockSettings.vue?vue&type=script&lang=js"
export * from "./BlockSettings.vue?vue&type=script&lang=js"
import style0 from "./BlockSettings.vue?vue&type=style&index=0&id=03e2b24c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e2b24c",
  null
  
)

export default component.exports